import { useState, useEffect } from 'react'
//import { UUID } from "uuidjs";
import useClient from './useClient'
import cloneDeep from 'lodash.clonedeep'

export default function useLayouts(_locationUUID = null) {
  const [layouts, setLayouts] = useState({})
  const {
    catalogLoading,
    client
  } = useClient()

  //const uid = useRef(UUID.generate())

  useEffect(() => {
    if (client != null && !catalogLoading) {
      setLayouts(cloneDeep(client.catalog?.layouts))
    }
  }, [catalogLoading, client])
  
  return {
    layouts
  }
}
